/* eslint-disable no-use-before-define */
'use strict';

var base = require('base/search/search');
var searchRefinements = require('./searchRefinements');

var searchExports = {};

Object.keys(base).forEach(key => {
    searchExports[key] = base[key];
});

function maxPriceReload() {
    searchRefinements.setMaxValue();
}
$(window).on('load', function () {
    searchRefinements.setMaxValue();
});

$(document).ready(function () {
    $('.close__custom').on('click', function () {
        if ($('#fromSlider').val() !== '0' || $('#toSlider') !== '1000000') {
            $('[data-search-prices]').click();
        }
    });
    pushProductImpressionGtmEvent();
});

$('body').on('search:showMoreFinished', function () {
    pushProductImpressionGtmEvent();
});

$('.container').on('click', '.product .product-tile', function (event) {
    var currentScrollPosition = window.scrollY;
    sessionStorage.setItem('scrollPosition', currentScrollPosition);
    try {
        var productTile = $(event.target).closest('.product-tile');
        var productGtmDataValue = $(productTile).find('.productGtmData').val();
        var productGtmData = JSON.parse(productGtmDataValue);
        var productPosition = $('.product-tile').index(productTile);
        productGtmData.position = productPosition + 1;
        delete productGtmData.currency;
        var list = $('.category-id').val();
        var productClickGtmEvent = {
            event: 'eec.productClick',
            ecommerce: {
                click: {
                    actionField: {
                        list: list
                    },
                    products: []
                }
            },
            eventCallback: function () {
            }
        };
        productClickGtmEvent.ecommerce.click.products.push(productGtmData);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(productClickGtmEvent);
    } catch (e) {
        // Nothing to do here
    }
});
/** NET-939 END **/

/**
 * DAB-4756 BEGIN - push datalayer Search event Google Tag manager
 */
var searchGtmHiddenInput = $('#searchGtmEvent').val();
var parsedSearchGtmValue = JSON.parse(searchGtmHiddenInput);
window.dataLayer = window.dataLayer || [];
window.dataLayer.push(parsedSearchGtmValue);
/**
 * DAB-4756 END
 */

$(document).on('click', '.refinement-pill-a', function () {
    let anyExpanded = false;

    $('.refinement-pill-a').each(function () {
        if ($(this).attr('aria-expanded') === 'true') {
            anyExpanded = true;
            return false;
        }
    });

    if (anyExpanded) {
        $('.refinements-container').addClass('refinements-track-scrollbar');
    } else {
        $('.refinements-container').removeClass('refinements-track-scrollbar');
    }
});

if ($('.swatch-circle-null')) {
    $('.swatch-circle-null').closest('.show-more-options-wrapper').hide();
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function createSearchShowUrlWithParams(showMoreUrlFromController) {
    var searchPattern = '/Search-UpdateGrid?';
    var showMoreUrl = showMoreUrlFromController;
    var modifiedUrlWithShowController = showMoreUrl.replace(searchPattern, '/Search-Show?');
    var url = new URL(modifiedUrlWithShowController);
    if (url.searchParams.has('sz') && url.searchParams.has('start')) {
        var startValue = Number(url.searchParams.get('start'));
        var szValue = Number(url.searchParams.get('sz'));
        var totalSize = startValue + szValue;
        var totalSizeToString = totalSize.toString();
        url.searchParams.set('sz', totalSizeToString);
        url.searchParams.set('start', '0');
        var updatedUrl = url.toString();
        return updatedUrl;
    }
    return modifiedUrlWithShowController;
}

function selectedCounter() {
    const refinementPills = $('.pills-container').find('.refinement-pill');

    if (refinementPills.length > 0) {
        $('#eraseFilters').removeClass('d-none');
    } else {
        $('#eraseFilters').addClass('d-none');
    }
}

function displayMessage() {
    const inputSelector = $('[data-js-invalid-filter]');
    let isInvalidFilter = false;

    if (inputSelector.length 
        && inputSelector.val() !== undefined 
        && inputSelector.val() !== null 
        && inputSelector.val() !== 'null' 
        && inputSelector.val() !== 'undefined' 
        && inputSelector.val().trim() !== ''
        && inputSelector.val()) {
        isInvalidFilter = inputSelector.val();
    }

    if (isInvalidFilter === 'true') {
        var errorMsg = $('<div>', {
            class: 'b-filter_error alert alert-danger',
            html: 'No hay productos cercanos a tu ubicación.<br>Sin embargo, te mostramos todos los productos disponibles para retiro ya.'
        })
        .attr('data-js-filter-error', '');
    
        $('body').append(errorMsg);
    
        setTimeout(() => {
            $('[data-js-filter-error]').remove();
        }, 12000);
    }
}

function updateUrlToFrendly(currentUrl) {
    var dataUrl = new URL(currentUrl);
    var isCategorySearch = $('#is-category-search').val() === 'true';
    var pathname;
    var newUrl;

    if (isCategorySearch) {
        pathname = $('#category-pathname').val();
    } else {
        pathname = $('#search-pathname').val();
    }

    newUrl = constructNewUrl(dataUrl, pathname);
    history.pushState(null, null, newUrl);
}

// return a string by newUrl//
function constructNewUrl(dataUrl, categoryPathname) {
    var filters;
    var newSearchParams;

    if (dataUrl.search.includes('prefv')) {
        filters = filterFrendly(decodeURI(dataUrl.search), categoryPathname);
        newSearchParams = getSearchParams(decodeURI(dataUrl.search));
        return getSearchParamsFilters(decodeURI(newSearchParams), decodeURI(filters));
    }
    newSearchParams = getSearchParams(decodeURI(dataUrl.search));
    if (newSearchParams) {
        return categoryPathname + '?' + newSearchParams.replace('?', '');
    }
    return categoryPathname;
}

function getSearchParamsFilters(newSearchParams, filters) {
    var result;
    if (newSearchParams) {
        if (new RegExp('^&').test(newSearchParams)) {
            result = replaceAccents(filters + newSearchParams.replace(new RegExp(/%252C/g), '%2C'));
        } else {
            result = replaceAccents(filters + newSearchParams.replace(new RegExp(/%252C/g), '%2C'));
        }
    } else {
        result = replaceAccents(filters);
    }
    return result;
}

function getSearchParams(dataUrlSearch) {
    return dataUrlSearch;
}

/** contruct newPathname = categoryPathname + filtersFrendly **/
function filterFrendly(dataUrl, categoryPathname) {
    return replaceAccents(categoryPathname);
}

/** replace Accents on string **/
function replaceAccents(stringToReplace) {
    var chars = {
        á: 'a',
        é: 'e',
        í: 'i',
        ó: 'o',
        ú: 'u',
        à: 'a',
        è: 'e',
        ì: 'i',
        ò: 'o',
        ù: 'u',
        ñ: 'n',
        Á: 'A',
        É: 'E',
        Í: 'I',
        Ó: 'O',
        Ú: 'U',
        À: 'A',
        È: 'E',
        Ì: 'I',
        Ò: 'O',
        Ù: 'U',
        Ñ: 'N'
    };
    var expr = /[áàéèíìóòúùñ]/ig;
    var res = stringToReplace.replace(expr, function (e) { return chars[e]; });
    return res;
}

/** NET-939 BEGIN **/
function pushProductImpressionGtmEvent() {
    try {
        var productGtmDataList = $('.productGtmData[data-gtmpushed!="true"]');
        if (productGtmDataList.length > 0) {
            var firstProductGtmData = JSON.parse($(productGtmDataList[0]).val());
            var currency = firstProductGtmData.currency;
            var productImpressionGtmEvent = {
                event: 'eec.productImpression',
                ecommerce: {
                    currencyCode: currency,
                    impressions: [
                    ]
                }
            };
            var lastPositionPushed = 0;
            var gtmLastPositionPushedElementList = $('.productGtmData[data-gtmlastpospushed]');
            if (gtmLastPositionPushedElementList.length > 0) {
                var lastPositionPushedValue = $(gtmLastPositionPushedElementList[0]).attr('data-gtmlastpospushed');
                lastPositionPushed = parseInt(lastPositionPushedValue, 10);
                $(gtmLastPositionPushedElementList[0]).removeAttr('data-gtmlastpospushed');
            }
            var productList = $('.category-id').val();
            productGtmDataList.each(function (position, productGtmDataElement) {
                var productGtmDataValue = $(productGtmDataElement).val();
                var productGtmData = JSON.parse(productGtmDataValue);
                lastPositionPushed++;
                productGtmData.position = lastPositionPushed;
                productGtmData.list = productList;
                delete productGtmData.currency;
                productImpressionGtmEvent.ecommerce.impressions.push(productGtmData);
                $(productGtmDataElement).attr('data-gtmpushed', 'true');
            });
            $(productGtmDataList[productGtmDataList.length - 1]).attr('data-gtmlastpospushed', lastPositionPushed);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(productImpressionGtmEvent);
        }
    } catch (ex) {
        // Nothing to do here
    }
}

/** Remove storeInventoryIds refinement attribute in specific case
 * @nameremoveStoreInventoryIds
 * @param {String} url
 * @returns {String}
 */
function removeStoreInventoryIds(url) {
    let availableForPickupRegex = /prefn\d+=availableForInStorePickup/;
    let storeInventoryIdsRegex = /prefn\d+=storeInventoryIds/;

    let hasAvailableForPickup = availableForPickupRegex.test(url);
    let hasStoreInventoryIds = storeInventoryIdsRegex.test(url);

    if (hasStoreInventoryIds && !hasAvailableForPickup) {
        url = url.replace(/&?prefn\d+=storeInventoryIds&?prefv\d+=[^&]*/, '');
        url = url.replace(/\?&/, '?'); // Corrige si queda "?&"
        url = url.replace(/&$/, ''); // Corrige si queda "&" al final
    }

    return url;
}

searchExports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(document).on('click', 'button.filter-results', function () {
            $('.refinement-bar').removeAttr('style');
            $('.carousel-fade').addClass('d-none');
            $('#maincontent').addClass('fixed');
            $('.refinement-bar').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
            $('body').css('overflow-y', 'hidden');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document).on('click', '.refinement-bar button.close', function () {
            $('.refinements-bar').attr('style', 'display: none');
            $('#maincontent').removeClass('fixed');
            $('.refinement-bar').hide();
            $('.carousel-fade').removeClass('d-none');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
            $('body').removeAttr('style');
        });
    },

    init: function () {
        $('body').on('click', '.show-more-options', function (event) {
            var $target = $(event.target);
            var optionsToShow = $target.siblings('.show-more-options-wrapper').not('.show-more-options-wrapper.active');
            var remainingElementsCount = optionsToShow.length;
            var loopEnd = remainingElementsCount > 5 ? 5 : remainingElementsCount;
            for (var i = 0; i < loopEnd; i++) {
                $(optionsToShow[i]).show();
                $(optionsToShow[i]).addClass('active');
            }
            if (remainingElementsCount > 5) {
                $target.parent().append($target.clone());
            }
            $target.remove();
        });
        $('.refinements-container').on('scroll', function (event) {
            event.stopPropagation();
        });
        var navigationEntries = performance.getEntriesByType('navigation');
        if (navigationEntries.length > 0) {
            var navigationEntry = navigationEntries[0];
            // Check the type of navigation
            switch (navigationEntry.type) {
                case 'back_forward':
                    var storedScrollPosition = sessionStorage.getItem('scrollPosition');
                    if (storedScrollPosition) {
                        window.scrollTo(0, parseInt(storedScrollPosition));
                    }
                    break;
                default:
                    sessionStorage.removeItem('scrollPosition');
                    break;
            }
        }
    },

    sort: function () {
        // Handle sort order menu selection
        let searchBackUrl = JSON.parse($('#searchBackUrl').val());
        if (searchBackUrl) { window.addEventListener('popstate', function (e) { location.reload(); }); }
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            var sortUrl = new URL(this.value);
            if (searchBackUrl) { updateUrlToFrendly(sortUrl); }
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var showMoreUrl = $(this).data('url');
            $.spinner().start();
            var updatedUrl = createSearchShowUrlWithParams(showMoreUrl);
            updateUrlToFrendly(updatedUrl);
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    var searchShowUrlWithParams = $('#searchShowUrlWithParams').val();
                    // updateUrlToFrendly(searchShowUrlWithParams);
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $('body').trigger('search:showMoreFinished', e);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // addEventListener in the back button ('popstate') reload the page to load the catalog with the filters located at the URL //
        let searchBackUrl = JSON.parse($('#searchBackUrl').val());
        if (searchBackUrl) { window.addEventListener('popstate', function (e) { location.reload(); }); }
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .refinement-pill .fa-close, .btn-close-icon',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                let target = $(this);
                if (searchBackUrl) { updateUrlToFrendly(location.origin + target.data('href')); }
                let url = target.data('href');
                url = removeStoreInventoryIds(url);
                const sruleValue = $('#product-search-results').attr('data-srule');
                const urlObj = new URL(url, window.location.href);
                urlObj.searchParams.set('srule', sruleValue);
                url = urlObj.toString();
                if (target.hasClass('reset')) {
                    url = target.data('href');
                    target.addClass('d-none');
                }
                if (searchBackUrl) { updateUrlToFrendly(location.origin + url); }
                $.spinner().start();
                target.trigger('search:filter', e);
                var min = $('[data-min-input-price]').val();
                var max = $('[data-max-input-price]').val();
                $.ajax({
                    url: url,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: url
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                        displayMessage();
                        searchRefinements.displayActualPriceFilter(min, max, target);
                        selectedCounter();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },
    getPage: function () {
        // get Page Paginate
        let searchBackUrl = JSON.parse($('#searchBackUrl').val());
        if (searchBackUrl) { window.addEventListener('popstate', function (e) { location.reload(); }); }
        $('.container').on('click', '.pagination-page', function (e) {
            e.stopPropagation();
            var pageUrl = $(this).data('url');
            if (searchBackUrl) { updateUrlToFrendly(pageUrl); }
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: pageUrl,
                data: { selectedUrl: pageUrl },
                method: 'GET',
                success: function (response) {
                    $('.row.product-grid').html(response);
                    updateSortOptions(response);
                    $('html, body').animate({ scrollTop: 0 }, 100);
                    $('body').trigger('search:showMoreFinished', e);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    updateSortUrl: function () {
        const searchParamName = 'srule';
        $('#product-search-results').on('search:sort', (e, url) => {
            const localUrl = new URL(url, window.location.href);
            const searchParamValue = localUrl.searchParams.get(searchParamName) || '';
            $('#product-search-results').attr('data-' + searchParamName, searchParamValue);
        });
    }
};
searchExports.resize = null;
module.exports = searchExports;
